import { SealCheck } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import UnverifiedIcon from 'assets/unverified.svg';
import WildcardIcon from 'assets/wildcard.svg';
import { BomLineType } from 'bom/enums';
import { Image, Tooltip } from 'core/elements';
import { theme } from 'theme';

export const LineTypeCell = ({ value }: ICellRendererParams) => {
  let icon = <></>;
  let tooltip = '';
  const style = { width: 24, height: 24 };

  switch (value) {
    case BomLineType.WILDCARD:
      tooltip = t('labelLineTypeWildcard');
      icon = <Image src={WildcardIcon} style={{ height: 22, width: 22 }} />;
      break;
    case BomLineType.VERIFIED:
      tooltip = t('labelLineTypeVerified');
      icon = <SealCheck weight="fill" style={{ ...style, color: theme.palette.success.solidBg }} />;
      break;
    case BomLineType.UNVERIFIED:
      tooltip = t('labelLineTypeUnverified');
      icon = <Image src={UnverifiedIcon} style={{ height: 22, width: 22 }} />;
      break;
    default:
      break;
  }

  if (!tooltip) {
    return;
  }

  return (
    <Tooltip title={tooltip} sx={{ justifyContent: 'center' }}>
      {icon}
    </Tooltip>
  );
};
